// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__hi3Mf","inner":"Footer_inner__Zvnmi"};